import {BillingAddressCommand} from '@domain/model/Account/Address/domain/model/BillingAddress/BillingAddressCommand';
import {BillingAddressRepository} from '@domain/model/Account/Address/domain/model/BillingAddress/BillingAddressRepository';

const SetBillingAddress =
  (
    billingAddressRepository: BillingAddressRepository,
  ): ((billingAddress: BillingAddressCommand) => Promise<Record<string, boolean> | null>) =>
  (billingAddress: BillingAddressCommand): Promise<Record<string, boolean> | null> => {
    const {name, lastName, address, postCode, city, phone} = billingAddress || {};
    if (!name || !lastName || !address || !postCode || !city || !phone) {
      return Promise.resolve(null);
    }

    return billingAddressRepository.setBillingAddress(billingAddress);
  };

export {SetBillingAddress};
